 import { useEffect, useState } from "react";

 import { orderBy, collection, query, getDocs, onSnapshot, where } from "@firebase/firestore";
 import ErrorPage from "../../shared/Error";
 import { db } from "../../../firebase";
 import React from "react";
 import { useParams } from "react-router-dom";
 import { useAuthState } from 'react-firebase-hooks/auth';
 import PostForm from "../../submit/PostForm";
 import { auth } from "../../../firebase";
 import QandaStrat from "./QandA"
import Qanda from "../../qanda/Qanda";
import'../../../../src/styles/scroll.css'
import { formatDistanceToNow } from 'date-fns';


 export default function TalkingTo(){ 
    const [formValue, setFormValue] = useState("")
  
    const [data, setdata] = useState([])
    
    const ref=query(collection(db, "q&a"))
    const queryRef=query(ref, orderBy('createdAt','desc'))
    const {aid}=useParams() 
    const authorq=query(collection(db, "users"), where("role", "array-contains", "Author"), where("username", "==", aid)

    )
    const [authors, setAuthors] = useState([])
 
    useEffect(() => {
        const subscribe=onSnapshot(authorq,(snapshot) => {
            setAuthors(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });
        
    }, []);
    
     
    useEffect(() => {
        const subscribe=onSnapshot(queryRef,(snapshot) => {
            setdata(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });
        
    }, []);
    const [a , setA] = useState('')
    const [user] = useAuthState(auth)
    const [strat, setStrat] = useState(null)
useEffect(() => {
    if (user) {
        const s = new QandaStrat(formValue, user, "q&a", aid);
        setStrat(s); 
    }
}, [formValue, user, aid]);

console.log(authors)
    if(!aid || authors.length===0) return <p>error</p>

    return (
        <> 
        <div class='flex flex-col mb-2 m-auto md:w-7/12 w-full justify-center '>
        <h1 className="text-xl font-bold m-auto">
            {aid}'s Q&A
        </h1>
        {!user ? <><p></p></> :  <PostForm formValue={formValue} setFormValue={setFormValue} setSelected={setA} Strat = {strat} yes={false}/>
}

        </div>
      
        {data
  .filter(obj => obj.data.author === aid)
  .map(obj => (
    <Messages key={obj.id} props={obj.data} id={obj.id} t={setA} u={user}/>
))}

        
       
        </> 
    )
}

function Messages({props,id,t,u}){
    const {author, user, text, replay, createdAt}=props
    
    return (
        <>
        
        <div class="mx-auto mb-5 border border-gray-300 rounded p-5 "  style={{maxHeightheight:'80vh'}}>
               
        <div class="div-class">
                        <div className="flex flex-row">
                        <div class='flex flex-start mb-5'> <span class='text-xs'>{props.useName} &middot; </span> </div>
                        {createdAt &&(
                             <div className="mb-1 text-xs ml-1 text-gray-500 ">{formatDistanceToNow(createdAt.toDate(), { addSuffix: true }).replace('about', '').trim()}</div>
                        )}
                       
                        </div>
    
                        <div className="">
                            <div className="w-full border border-gray-600 mt-1 mb-5"></div>
                        <div className=" scrollbar"style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                            <div dangerouslySetInnerHTML={{ __html: text }}/>
                            </div>
                        <div className="w-full border border-gray-600 mt-4 mb-6"></div>
                            {replay&&(
                                  
                                  <div className="scrollbar" style={{ maxHeight: '20vh', overflowY: 'auto' }}>
                                      {replay.map((item, index) => (
                                          <div className='flex flex-row items-center'key={index} >
                                              <p className="mr-1 text-xs">{item.name}</p>
                                              <div dangerouslySetInnerHTML={{ __html: item.text }} />
                                          </div>
                                      ))}
                                  </div>
                            )}
                          
                        </div>
                        {u &&(
                              <div class="mt-4">
                              <Qanda t={t} id={id} u={u}/>
                          </div>
                        )}
                      
                    </div>
             
            </div>

        </>
    )
}

